'use client';

import { lazy, Suspense } from 'react';
import type { ComponentProps } from 'react';
import type { ReservationForm } from './steps/reservation-form-steps';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

const MeetingForm = lazy(() =>
  import('./steps/reservation-form-steps').then(module => ({ default: module.ReservationForm })),
);

// Only mounted by the open Modal content, not by its always-visible trigger.
export function DeferredMeetingForm(props: ComponentProps<typeof ReservationForm>) {
  const { t } = useTranslations();
  return (
    <Suspense
      fallback={
        <div
          role="status"
          aria-label={t('text3968')}
          aria-busy="true"
          className="h-64 animate-pulse rounded-2xl bg-primary/10"
        />
      }
    >
      <MeetingForm {...props} />
    </Suspense>
  );
}
